export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/topojson/node_modules/topojson-client/src/identity.js
// module id = 18
// module chunks = 0 1